// External Links Warning
document.addEventListener('DOMContentLoaded', () => {
  const handleExternalLinks = () => {
    const links = document.querySelectorAll('a');
    const excludedLinks = []; // You can populate this array with links you want to exclude from the external link handling

    const isThirdParty = (url) => {
      try {
        const linkHost = new URL(url).hostname;
        const currentHost = window.location.hostname;
        return linkHost && linkHost !== currentHost;
      } catch (e) {
        return false;
      }
    };

    links.forEach(link => {
      const href = link.getAttribute('href');
      if (!href || !isThirdParty(href) || excludedLinks.includes(href)) return;

      // Open in new tab
      link.setAttribute('target', '_blank');

      // Set aria-label
      const existingText = link.textContent.trim();
      const ariaLabel = `${existingText}, This link will open in a new tab`;
      link.setAttribute('aria-label', ariaLabel);

      // Update image alt text
      const img = link.querySelector('img, svg');
      if (img) {
        let altText = img.getAttribute('alt') || '';
        const updatedAlt = altText
          ? `${altText}, This link will open in a new tab`
          : 'This link will open in a new tab';
        img.setAttribute('alt', updatedAlt);
      }
    });
  };

  // Adding timeout to ensure the DOM is fully loaded
  setTimeout(() => {
    handleExternalLinks();
  }, 500); // Adjust the timeout duration as needed (500ms here)
});

 
// Email and phone number labels
document.addEventListener('DOMContentLoaded', () => {
  const handleContactLinks = () => {
    const links = document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]');
 
    links.forEach(link => {
      const href = link.getAttribute('href');
      const linkText = link.textContent.trim();

      if (href.startsWith('mailto:')) {
        link.setAttribute('aria-label', `${linkText} on email`);
      } else if (href.startsWith('tel:')) {
        link.setAttribute('aria-label', `Phone number: ${linkText}`);
      }
    });
  };
 
  handleContactLinks();
});

///add aria-hidden="true" on all br tags

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('br').forEach(function(br) {
    br.setAttribute('aria-hidden', 'true');
  });
});

document.addEventListener("DOMContentLoaded", function () {

  // Select all primary buttons
  var buttons = document.querySelectorAll('.button.button--primary');

  buttons.forEach(function(button) {

    // Button ka apna text
    var buttonText = button.textContent.trim();

    // Closest rich-text__blocks center container
    var blocksContainer = button.closest('.rich-text__blocks.center');

    if (blocksContainer) {

      // Heading find kare (h1–h6)
      var heading = blocksContainer.querySelector('h1, h2, h3, h4, h5, h6');

      if (heading) {

        var headingText = heading.textContent.trim();

        // Aria label set kare
        button.setAttribute('aria-label', buttonText + ', ' + headingText);

      }
    }

  });

});




// image and text js 



document.addEventListener("DOMContentLoaded", function () {

  // Select all primary buttons inside image-with-text section
  var buttons = document.querySelectorAll('.image-with-text__content .button.button--primary');

  buttons.forEach(function(button) {

    // Button ka apna text
    var buttonText = button.textContent.trim();

    // Closest content container
    var contentContainer = button.closest('.image-with-text__content');

    if (contentContainer) {

      // Heading find kare
      var heading = contentContainer.querySelector('.image-with-text__heading');

      if (heading) {

        var headingText = heading.textContent.trim();

        // Aria label set kare
        button.setAttribute('aria-label', buttonText + ', ' + headingText);

      }
    }

  });

});

// Wishlist trigger: keep focus on the same product item after activation
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-iwish-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var el = this;
      requestAnimationFrame(function () {
        setTimeout(function () {
          if (el && document.body.contains(el)) {
            el.focus();
          }
        }, 150);
      });
    });
  });
});